import React from "react";

const OrdersContext = React.createContext(null);


export default OrdersContext;